export const UPLOAD_CONFIG = {
  maxSize: 15000000,
  acceptFormat: {
    "text/csv": [".csv"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  },
  matchFormat: /^(.xls|.xlsx|.csv|application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet|application\/vnd.ms-excel|text\/csv)$/,
}
